var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitleFrame',{attrs:{"text":"利用規約への同意"}},[_c('template',{slot:"contents"},[_c('ConsentCheck',{attrs:{"is-test":_vm.isTest},on:{"click-agree":_vm.onClickAgree}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d69f512e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Consent.vue
// module id = null
// module chunks = 